import React from 'react';
import '../../App.css';
import '../../bootstrap.css';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';
import {FOOD_TAGS} from '../../helpers/Util';

let foodTagsList = Object.keys(FOOD_TAGS).map(tagKey => valueToReactSelectListItem(FOOD_TAGS[tagKey]));

function valueToReactSelectListItem(value) {
  return {label: value, value: value}; // ReactSelect requires the list items to have label and value fields.
}

function reactSelectListItemToValue(listItem) {
  return listItem.value;
}

function convertTagsToReactSelectTags(tags) {
  return tags ? tags.map(tag => valueToReactSelectListItem(tag)) : [];
}

export default class FoodTagsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tagItems: convertTagsToReactSelectTags(this.props.tags)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.tags != this.props.tags) {
      this.setState({tagItems: convertTagsToReactSelectTags(nextProps.tags)});
    }
  }
  
  tagClicked(tagItems) {
    this.setState({tagItems});
    this.props.tagsChange(tagItems.map(tagItem => reactSelectListItemToValue(tagItem)));
  }

  render() {
    let foodTagsDropdown = (<ReactSelect
      closeOnSelect={false}
      multi={true}
      onChange={this.tagClicked.bind(this)}
      options={foodTagsList}
      placeholder="Food tag required!"
      removeSelected={this.state.removeSelected}
      value={this.state.tagItems}
      style={{borderColor: this.state.tagItems && this.state.tagItems.length ? 'gray' : 'red', height:'20px'}}
      wrapperStyle={{top: '12px'}}
      menuContainerStyle={{maxHeight:'800px'}}
      menuStyle={{maxHeight:'800px'}}
    />);

    return (
      <span style={{display:'inline-block', minWidth:'300px', maxWidth:'400px', maxHeight: '500px'}}>
        {foodTagsDropdown}
      </span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/FoodTagsForm.js